export default "__VITE_ASSET__BkQtnE2Q__"